import CylinderGeometry from "./cylinder-geometry";
import ConeGeometry from "./cone-geometry";
import LozangleGeometry from "./lozangle-geometry";
import PyramidGeometry from "./pyramid-geometry";
import RingGeometry from "./ring-geometry";
import SphereGeometry from "./sphere-geometry";
import TrapezeGeometry from "./trapeze-geometry";
import TriangleGeometry from "./triangle-geometry";
import BoxGeometry from "./box-geometry";

export default{
  BoxGeometry,
  ConeGeometry,
  LozangleGeometry,
  PyramidGeometry,
  RingGeometry,
  SphereGeometry,
  TrapezeGeometry,
  TriangleGeometry,
  CylinderGeometry,
};
